import Vue from "vue";
import App from "./App.vue";
import VueI18n from "vue-i18n";

Vue.config.productionTip = false;
Vue.use(VueI18n);

const messages = {
  en: {
    header: {
      buttons: { intro: "What’s KŪKI?", contact: "Contact us" }
    },
    section: {
      intro: {
        title: "What’s KŪKI?",
        content:
          "KŪKI is a green tech social project that uses the power of plants and natural resources to promote public wellbeing by creating comfortable, beautiful and healthy indoor spaces."
      },
      features: {
        feature_1: "Improve air quality in indor spaces",
        feature_2: "Improve wellbeing",
        feature_3: "Reduce city traffic"
      },
      contact: {
        tagline: "Give us some love!",
        button: "Mail us"
      }
    },
    footer: {
      instagram: "Follow us on Instagram"
    }
  }
};

const i18n = new VueI18n({
  locale: "en",
  messages
});

new Vue({
  render: h => h(App),
  i18n
}).$mount("#app");
